import { render, staticRenderFns } from "./LodgingSkeleton.vue?vue&type=template&id=2ce76f4d&scoped=true&"
import script from "./LodgingSkeleton.vue?vue&type=script&lang=js&"
export * from "./LodgingSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LodgingSkeleton.vue?vue&type=style&index=0&id=2ce76f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce76f4d",
  null
  
)

export default component.exports